import { CheckOutlined, CloseOutlined } from "@ant-design/icons";
import { ApiResponseError } from "@axl-dev/school-sdk";
import { Button, Spin, Input, Alert, Row, Form } from "antd";
import { Rule } from "antd/es/form";
import { useForm } from "antd/es/form/Form";
import moment from "moment";
import { FC, useMemo, useState } from "react";

import { useLoc, useSdk } from "@app/shared/lib/hooks";
import { useUser } from "@app/shared/lib/hooks/useUser";

type EmailChangeFormProps = {
  onEmailChanged: () => void;
  onCancel: () => void;
};

export const EmailChangeForm: FC<EmailChangeFormProps> = ({
  onCancel,
  onEmailChanged,
}) => {
  const loc = useLoc();
  const [form] = useForm();
  const [isSaving, setSaving] = useState(false);
  const [errors, setErrors] = useState<ApiResponseError[]>([]);
  const emailRules: Rule[] = useMemo(
    () => [
      {
        required: true,
        message: loc.word("Required field"),
      },
      {
        type: "email",
        message: loc.word("Enter valid email"),
      },
    ],
    [loc],
  );
  const user = useUser();
  const sdk = useSdk();

  const handleSubmit = async (values: { email: string }) => {
    try {
      setSaving(true);
      setErrors([]);
      const newUser = user.user!;
      const result = await sdk.api.account.save({
        avatar: newUser.avatar,
        birthday: newUser.birthday ? moment(newUser.birthday) : undefined,
        email: values.email.trim(),
        firstName: newUser.firstName,
        lastName: newUser.lastName,
        gender: newUser.gender ?? undefined,
        middleName: newUser.middleName,
        phone: newUser.phone,
      });
      // runInAction(() => {
      // this.isEmailSaving = false;
      // this.errors = result.response.errors;
      // });
      if (!result.success) {
        setErrors(errors);
      }

      setSaving(false);

      if (result.success) {
        onEmailChanged();
      }

      return result.success;
    } finally {
      setSaving(false);
    }
  };

  return (
    <>
      <Spin tip={loc.word("Loading")} spinning={isSaving}>
        {errors.map((x) => (
          <Alert key={x.code} message={x.message} type="error" />
        ))}
        <Form
          form={form}
          name="changeEmail"
          onFinish={handleSubmit}
          initialValues={{
            email: user.user?.email,
          }}
          layout="vertical"
        >
          <Form.Item label={loc.word("Email")} name="email" rules={emailRules}>
            <Input
              placeholder={loc.word("Enter email")}
              //   onChange={(e) => {
              //     this.store.setEmail(e.target.value?.trimSpaces());
              //     this.formRef.current!.setFieldsValue({
              //       email: this.store.email,
              //     });
              //   }}
              autoFocus
            />
          </Form.Item>
        </Form>
      </Spin>
      <footer>
        <Row justify="space-between">
          <Button onClick={() => onCancel()} icon={<CloseOutlined />}>
            {loc.word("Cancel")}
          </Button>
          <Button
            htmlType="submit"
            form="changeEmail"
            type="primary"
            loading={isSaving}
            icon={<CheckOutlined />}
          >
            {loc.word("Save")}
          </Button>
        </Row>
      </footer>
    </>
  );
};
